import { IconButton, Stack, Typography } from '@mui/material'
import { Icons } from 'utoniq-ui'

import { Organism, OrganismFrame } from '@/core/architecture'

export type QuantityPickerProps = {
  value: number
  onPlus: () => void
  onMinus: () => void
  error?: boolean
  disabledPlus?: boolean
}

export const QuantityPicker: Organism<QuantityPickerProps> = ({
  value,
  onPlus,
  onMinus,
  error,
  disabledPlus,
}) => {
  return (
    <OrganismFrame>
      <Stack direction="row" spacing={5} alignItems="center">
        <IconButton
          size="xSmall"
          onClick={onMinus}
          sx={{
            width: 24,
            height: 24,
            bgcolor: 'grey.100',
            '&.Mui-disabled': { bgcolor: 'grey.100' },
          }}
          disabled={value <= 1}
        >
          <Icons.Minus
            sx={{
              width: 16,
              height: 16,
              color: value <= 1 ? 'text.disabled' : 'grey.700',
            }}
          />
        </IconButton>
        <Typography variant="caption" color="text.primary">
          {value}
        </Typography>
        <IconButton
          size="xSmall"
          onClick={onPlus}
          disabled={error || disabledPlus}
          sx={{
            width: 24,
            height: 24,
            bgcolor: 'grey.100',
            '&.Mui-disabled': { bgcolor: 'grey.100' },
          }}
        >
          <Icons.Plus
            sx={{
              width: 16,
              height: 16,
              color: error || disabledPlus ? 'text.disabled' : 'grey.700',
            }}
          />
        </IconButton>
      </Stack>
    </OrganismFrame>
  )
}
